<script setup>
  import { ref, computed } from "vue";
  import { useUserStore } from "@/stores/UserStore";
  import { useSheetController } from '@/composables/useSheetsController';
  import MapSourceSelectorBase from "@/components/MapSourceSelectorBase.vue";
  import Icon from "./icons/Icon.vue";
  
  const userStore = useUserStore();

  let isLoading = ref(true);

  await userStore.getProfiles();

  if (!userStore.currentProfileId) userStore.setCurrentProfile();

  const userProfileName = computed(() => {
    if (isLoading.value) {
      return "Loading Profiles...";
    } else if (!userStore.currentProfile) {
      return "There was an error loading profiles";
    } else {
      return userStore.currentProfile.name;
    }
  });

  const spotCount = computed(() => {
    if (isLoading.value || !userStore.currentProfile) {
      return 0;
    } else {
      return userStore.currentProfile.favorite_spots.length;
    }
  });

  isLoading.value = false;

  function handleShowModelSheet() {
    useSheetController.toggleSheet('source', 'user-profiles', true);
  }

</script>

<template>
  <MapSourceSelectorBase
    @showSheet="handleShowModelSheet"
  >
    <template #icon>
      <Icon name="star" />
    </template>
    <template #label>
      {{ userProfileName }}
    </template>
    <template #badge>
      <span class="jwx-source-selector__meta jwx-source-selector__meta--pill">{{ spotCount }}</span>
    </template>
  </MapSourceSelectorBase>
</template>